import styled from 'styled-components';
import theme from '../../theme';

export const TerminalBox = styled.div`
  background: ${theme.colors.bgTertiary};
  border: 1px solid ${theme.colors.borderBright};
  border-radius: ${theme.borderRadius.md};
  padding: ${theme.spacing.lg};
  box-shadow: ${theme.shadows.glow};
  font-family: ${theme.fonts.mono};
  color: ${theme.colors.text};
  position: relative;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 2px;
    background: ${theme.colors.primary};
    box-shadow: ${theme.shadows.glow};
  }
  
  &:hover {
    box-shadow: ${theme.shadows.glowStrong};
    border-color: ${theme.colors.primaryLight};
  }
`;

export const TerminalCard = styled.div`
  background: ${theme.colors.bgTertiary};
  border: 1px solid ${theme.colors.border};
  border-radius: ${theme.borderRadius.md};
  padding: ${theme.spacing.xl};
  box-shadow: ${theme.shadows.card};
  font-family: ${theme.fonts.mono};
  color: ${theme.colors.text};
  transition: all ${theme.transitions.normal};
  
  &:hover {
    border-color: ${theme.colors.borderBright};
    box-shadow: ${theme.shadows.glow};
    transform: translateY(-2px);
  }
`;

export const TerminalButton = styled.button`
  background: transparent;
  border: 1px solid ${theme.colors.borderBright};
  color: ${theme.colors.text};
  padding: ${theme.spacing.sm} ${theme.spacing.lg};
  font-family: ${theme.fonts.mono};
  font-size: 0.875rem;
  cursor: pointer;
  transition: all ${theme.transitions.fast};
  text-transform: uppercase;
  letter-spacing: 1px;
  position: relative;
  overflow: hidden;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: ${theme.colors.overlayLight};
    transition: left ${theme.transitions.normal};
  }
  
  &:hover {
    background: ${theme.colors.overlayLight};
    box-shadow: ${theme.shadows.glow};
    border-color: ${theme.colors.primaryLight};
    
    &::before {
      left: 100%;
    }
  }
  
  &:active {
    transform: scale(0.98);
  }
  
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    border-color: ${theme.colors.border};
  }
`;

export const TerminalInput = styled.input`
  background: ${theme.colors.bgSecondary};
  border: 1px solid ${theme.colors.border};
  color: ${theme.colors.text};
  padding: ${theme.spacing.sm} ${theme.spacing.md};
  font-family: ${theme.fonts.mono};
  font-size: 0.875rem;
  border-radius: ${theme.borderRadius.sm};
  transition: all ${theme.transitions.fast};
  
  &:focus {
    outline: none;
    border-color: ${theme.colors.borderBright};
    box-shadow: 0 0 10px ${theme.colors.overlayLight};
  }
  
  &::placeholder {
    color: ${theme.colors.textMuted};
  }
`;

export const TerminalText = styled.span`
  font-family: ${theme.fonts.mono};
  color: ${theme.colors.text};
  
  &.prompt {
    color: ${theme.colors.primary};
    &::before {
      content: '${theme.terminal.prompt} ';
    }
  }
  
  &.success {
    color: ${theme.colors.success};
  }
  
  &.error {
    color: ${theme.colors.error};
  }
  
  &.warning {
    color: ${theme.colors.warning};
  }
`;

export const TerminalTitle = styled.h1`
  font-family: ${theme.fonts.mono};
  color: ${theme.colors.text};
  font-size: 2rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 2px;
  text-shadow: ${theme.shadows.glow};
  margin: 0;
  
  &.large {
    font-size: 3rem;
  }
  
  &.small {
    font-size: 1.5rem;
  }
`;

export const TerminalSubtitle = styled.h2`
  font-family: ${theme.fonts.mono};
  color: ${theme.colors.textSecondary};
  font-size: 1.25rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1px;
  margin: 0;
`;

